/* eslint-disable quotes */
export default {
  studio_info: 'Studio Info',
  studio_name: 'Studio Name',
  studio_name_lowercase: 'Studio name',
  studio_id: 'Studio ID',
  new_studio_button: 'Create New Studio',
  new_studio: 'New Studio',
  apply_to_join: 'Apply to join',
  please_choose_a: 'PLEASE CHOOSE A ',
  studio: 'STUDIO',
  apply_to_join_upper: 'Apply to Join',
  studio_setting_delete_success:
    '{{studioName}} has been deleted successfully!',
  studio_setting_delete_failed: 'Failed to delete {{studioName}}',
  studio_setting_put_name_success:
    'You have successfully changed the studio name.',
  studio_setting_put_name_failed: 'Edit studio name failed!',
  delete_studio: 'Delete Studio',
  delete_studio_confirm_desc:
    'Are you sure you want to delete the studio: {{studioName}}? This will permanently delete the organization and all associated data.',
  delete_studio_failed_desc:
    'Titles still exist under this studio. Please delete all titles associated with this studio before proceeding with this operation.',
  delete_studio_failed: 'Delete failed',
  delete_studio_permanently_tip:
    'Click Delete Studio to start the process of permanently deleting the studio and organization.',
  join_success: 'Join success.',
  studio_application_sent_success: 'Your application successfully sent.',
  studio_invitation_already_sent:
    'Your application has already been sent to the studio, please patiently wait for 24 hours.',
  studio_not_exist: 'This studio does not exist.',
  only_join_one: 'You can only join one studio.',
  already_joined_this_studio:
    'Application failed, you have already joined this studio.',
  fail_to_apply: 'Fail to apply.',
  please_enter_studio: 'Please enter the studio id you want to apply for',
  please_enter_studio_id: 'Please enter the studio id',
  reason: 'Reason',
  please_enter_reason_desc: 'Please enter the reason for application',
  please_enter_reason: 'Please enter your reason',
  send: 'Send',
  create_studio_success: 'Create studio success!',
  create_studio_fail: 'Create studio fail!',
  maximum_max_lint_characters: 'Maximum {{maxLimit}} characters',
  please_enter_your_studio_name: 'Please enter your studio name',
  create_now: 'Create Now',
  no_studio_title: 'There are no studios and titles in your portal.',
  no_studio_content:
    'You can start using it by creating a new studio or submitting an application to another studio.',
  operate_success: 'Operate success.',
  operate_fail: 'Operate fail.',
  user_already_joined_another_studio:
    'This user has already joined another studio.',
  sure_approve_applicant: 'Are you sure you want to approve the applicant?',
  sure_reject_applicant: 'Are you sure you want to reject the applicant?',
  role: 'Role',
  no_pending_invitations: 'There are no pending invitations.',
  remove_success: 'Remove success!',
  remove_fail: 'Remove fail.',
  remove_failed: 'Remove Failed',
  can_not_remove_oneself: "Can't remove oneself.",
  transfer_success: 'Transfer success!',
  transfer_fail: 'Transfer fail.',
  transfer: 'Transfer',
  transfer_permission: 'Transfer Permission',
  remove_member: 'Remove Member',
  sure_quit_organization: 'Are you sure you want to quit the organization:',
  sure_transfer_permission:
    'Are you sure you want to transfer your Owner permission to:',
  // owner只能转移给admin角色
  sure_transfer_permission_desc2:
    'And your permission will be automatically changed to Admin.',
  transfer_owner_role_first:
    'You need to transfer the owner role to someone else first.',
  invite: 'Invite',
  invite_member: 'Invite Member',
  search_name: 'Search Name',
  invite_success: 'Invite has been successfully sent.',
  invite_fail: 'invite failed.',
  please_select: 'Please select!',
  format_verification_error: 'Format verification error',
  enter_wecom_name: 'Enter the wecom name',
  enter_email_address: 'Enter the email address',
  organization: 'Organization',
  members: 'Members',
  applications: 'Applications',
  create_new_title: 'Create New Title',
  portal: 'PORTAL',
  my_studios_portal: 'My Studios Portal',
  last_update: 'Last Update : ',
  services_focus_innovation: 'InGame services make you focus on innovation',
  services_focus_innovation_cn: '',
  // 工作室下展示的文档
  doc_in_game_services_title: 'InGame Services',
  doc_in_game_services_content: 'Browse InGame documentation and guides.',
  sample_demo_tutorials_title: 'Sample Demo Tutorials',
  sample_demo_tutorials_content:
    'The tutorials will give you firsthand experience integrating and using InGame.',
  sdks_tools_title: 'SDKs & Tools',
  sdks_tools_content: 'Integrate our services into your game using our SDKs.',
  knowledge_base_title: 'Knowledge Base',
  knowledge_base_content:
    'Find more information on release notes and best practices related to Ingame here!',
  get_up_to_speed_steps_desc:
    'Get up to speed on InGame and complete your initial setup in simple steps with our quick start guide!',
  get_started_title: 'Get started with Tencent Games InGame',
  get_started_content: 'InGame services make you focus on innovation',
  learn_more: 'Learn more',
  setting: 'SETTING',
  setting_name: 'Setting',
  user_already_invited_or_member:
    'This user is already invited or a member of the Organization.',
  go_to_website: 'Go to website',
  only_numbers: 'Only numbers are allowed to be entered.',
};
